import {Injectable} from '@angular/core';
import {ApiConfig} from './config.api';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {GENERAL_CONSTANTS} from '../../constants/constant';
import {API_CONSTANTS, SERVICE_CONSTANTS} from '../../constants/apiConstant';

@Injectable()
export class DocumentResourceApi {
  constructor(private httpClient: HttpClient) {
  }

  public webServiceUrl: string = ApiConfig.baseURL + SERVICE_CONSTANTS.WEB_SERVICE + GENERAL_CONSTANTS.SLASH;

  delete(documentCode) {
    return this.httpClient.delete(ApiConfig.baseURL + 'api/documents?docCodes=' + documentCode);
  }

  downloadBenefitStatement(keyword: string, startDate: string, endDate: string, language: string) {
    const queryString = 'searchString=' + keyword + '&startDate=' + startDate + '&endDate=' + endDate + '&lang=' + language;
    this.openNewTab(ApiConfig.baseURL + 'api/documents/balance/general?' + queryString, true);
  }

  getCertificate(openNewTabStatus: boolean) {
    this.openNewTab(ApiConfig.baseURL + 'api/documents/certificate', openNewTabStatus);
  }

  getCertificateByKeyword(keyword: string, openNewTabStatus: boolean) {
    this.openNewTab(ApiConfig.baseURL + 'api/documents/certificate?searchString=' + keyword, openNewTabStatus);
  }

  download(downloadCode, filename, extension): Observable<Blob> {
    return this.httpClient.get(ApiConfig.baseURL + 'api/documents/download/' + downloadCode, {
      headers: ApiConfig.requestOptionsHeaderForDownload(filename, extension),
      responseType: "blob"
    });
  }

  downloadDocumentSourceFile(formData: FormData, token): Observable<Blob> {;
    const documentType = formData.get("documentType") as string || 'template';
    const docCaption = formData.get("docCaption") as string;
    const docExtension = formData.get("docExtension") as string;

    const endpoint: string = API_CONSTANTS.DOWNLOAD_DOCUMENT + `/${docCaption}.${docExtension}/${documentType}`;
    const url: string = this.webServiceUrl + endpoint;
    let headers = ApiConfig.requestOptionsHeaderForDownload(docCaption, docExtension);
    if (token) {
      headers = headers.set('Authorization', token);
    }

    return this.httpClient.get(url, {
      headers: headers,
      responseType: "blob"
    });
  }

  getByKeyword(title, selectedProductId,  page, size) {
    return this.httpClient.get(ApiConfig.baseURL + 'api/documents/page?title='
    + title
    + '&productId='
    + selectedProductId
    + '&page=' + page + '&size=' + size, {headers: ApiConfig.requestOptionsHeader});
  }

  upload(formData) {
    return this.httpClient.post(ApiConfig.baseURL + 'api/documents/upload', formData);
  }

  uploadDocumentSourceFile(formData: FormData, token) {
    const endpoint: string = API_CONSTANTS.UPLOAD_DOCUMENT;
    const url: string = this.webServiceUrl + endpoint;

    let headers = ApiConfig.requestOptionsHeader
      .delete('Content-Type');
    if (token) {
      headers = headers.set('Authorization', token);
    }

    return this.httpClient.post(url, formData, {
      headers: headers,
    });
  }

  downloadDataDetail(downloadCode) {
    this.openNewTab(ApiConfig.baseURL + 'api/documents/' + downloadCode, false)
  }

  openNewTab(url: string, openNewTab: boolean) {
    const linkTarget = (openNewTab ? '_blank' : '_self');
    window.open(url, linkTarget);
  }
}
